export const DESKTOP_SMALL = 1440;